import { Box, Typography } from "@mui/material";
import useColors from "../../../../api/hooks/useColors";
import usePermissionType from "./usePermissionType";

const PermissionDetails = ({ permission }) => {
  const colors = useColors();
  const getPermissionType = usePermissionType();

  const {
    icon: Icon,
    borderColor,
    permissionLabel,
  } = getPermissionType(permission.admin_type, permission?.admin_category);
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Box display="flex" flexDirection="row" gap={1}>
        {Icon && <Icon />}
        <Typography variant="caption">{permissionLabel}</Typography>
      </Box>
    </Box>
  );
};

export default PermissionDetails;
